export type InitializationErrorContext = Record<
  string,
  string | number | boolean | undefined
>;

// Datadog RUM reads `dd_context` off an error passed to console.error and records it as the event's context.
export class InitializationError extends Error {
  declare readonly dd_context: InitializationErrorContext;

  constructor(
    message: string,
    context: InitializationErrorContext,
    options?: ErrorOptions,
  ) {
    super(message, options);
    Object.defineProperties(this, {
      name: { value: 'InitializationError', enumerable: false },
      dd_context: { value: context, enumerable: false },
    });
  }
}
